import { render, staticRenderFns } from "./SafetyProblem.vue?vue&type=template&id=4ee0e7d4&scoped=true"
import script from "./SafetyProblem.vue?vue&type=script&lang=js"
export * from "./SafetyProblem.vue?vue&type=script&lang=js"
import style0 from "./SafetyProblem.vue?vue&type=style&index=0&id=4ee0e7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee0e7d4",
  null
  
)

export default component.exports